import config from '@/config';
import { ApiBase } from '@/api/common';
import ListeningItem from '@/api/listeningItem';

const NO_UPLOAD_FIELDS = ['items'];

export default class ListeningContent extends ApiBase<ListeningContent> {
  public static readonly SLUG: string = 'exercise-listening-content';
  private static readonly URL_BASE: string =
    config.API_ROOT + '/exercise-listening-content/';

  // Initializing these fields (even with undefined)
  // is necessary, so hasOwnAttribute can find them.

  public items: ListeningItem[] = [new ListeningItem(0), new ListeningItem(1)];
  public correct_index: number = 0;
  public parent_exercise?: number = undefined;

  // currently unused
  public spreadsheet?: string = undefined;

  public constructor() {
    super({
      urlBase: ListeningContent.URL_BASE,
      filteredFields: NO_UPLOAD_FIELDS
    });
  }

  public assign(response: any): ListeningContent {
    super.assign(response);
    if (response && 'items' in response) {
      this.items[0] = new ListeningItem().assign(response.items[0]);
      this.items[1] = new ListeningItem().assign(response.items[1]);
    }
    return this;
  }

  public async save(): Promise<number> {
    const id = await super.save();
    this.items[0].parent_exercise = this.parent_exercise;
    this.items[1].parent_exercise = this.parent_exercise;

    await Promise.all([
      (this.items[0] as ListeningItem).save(),
      (this.items[1] as ListeningItem).save()
    ]);
    return id;
  }
}
